<app-details-card *ngFor="let enrollmentDetail of enrollmentDetails" [title]="enrollmentDetail.title"
    [editPath]="enrollmentDetail.editPath">
    <ng-container *ngFor="let item of enrollmentDetail.items">
        <div *ngIf="!item.hidden && !item.customTemplate" class="detail-container">
            <h4 class="detail-name">{{item.detailName}}</h4>
            <!-- <h4 class="detail-value">{{item.detailValue || '-'}}</h4> -->
            <h4 class="detail-value">
                {{item.detailValue !== null && item.detailValue !== undefined && item.detailValue !== '' ? item.detailValue : '-'}}
              </h4>
              
              
        </div>
        <div class="detail-container" *ngIf="!item.hidden && item.customTemplate">
            <h4 class="detail-name">{{item.detailName}}</h4>
            <h4 class="detail-value" [matTooltip]="item.detailValue" [matTooltipDisabled]="!item.detailValue"
                matTooltipClass="tooltip">
                <mat-icon *ngIf="item.detailValue?.toLowerCase().includes('.pdf')" svgIcon="document-pdf"></mat-icon>
                <mat-icon *ngIf="item.detailValue?.toLowerCase().includes('.png')" svgIcon="document-png"></mat-icon>
                <span *ngIf="!item.detailValue">-</span>
            </h4>
        </div>
    </ng-container>
</app-details-card>

<div class="signature-button-container">
    <button class="button-Secondary" color="primary" (click)="onSave(true)">Save And Exit</button>
    <button class="button-Primary" color="primary" (click)="onSave()">NEXT : {{nextStep?.enrollmentStepName}}</button>
</div>

<loading-spinner *ngIf="isLoading"></loading-spinner>